import queryString from "query-string";
import {
  ALL_IMPREST_STATES_ARRAY,
  DEFAULT_IMPREST_FILTER_STATES,
  IMPREST_STATES,
  TEAM_IDS,
  USER_IDS
} from "../../../../constants/filters";
import {
  GetIdsList,
  GetImprestStateList
} from "../../../../assets/convertUrlFilter";

export const GetNumberFilter = () => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters);
};

const filtersNormalize = filters => {
  return {
    [IMPREST_STATES]: GetImprestStateList(
      filters[IMPREST_STATES],
      ALL_IMPREST_STATES_ARRAY
    ),
    [USER_IDS]: GetIdsList(filters[USER_IDS]),
    [TEAM_IDS]: GetIdsList(filters[TEAM_IDS])
  };
};
